import { Component, OnInit, Input } from '@angular/core';
import { InscricaoAlunoService} from '../inscricao-aluno/inscricao-aluno.service';
import { Orcamento} from './orcamento';
import { MatSnackBar  } from '@angular/material';

@Component({
  selector: 'orcamento',
  templateUrl: './orcamento.component.html',
  styleUrls: ['./orcamento.component.css']
})
export class OrcamentoComponent implements OnInit {
  @Input() periodo: number;
  constructor(private inscricaoAlunoService: InscricaoAlunoService, public mensagem: MatSnackBar,) { }
  public isLoading: boolean;
  public orcamento: Orcamento;

  public consolidadoString;
  public orcamentoString;
  public previstoString;

  public corBotaoConsolidado = "accent";
  public corBotaoPrevisto = "accent";

  ngOnInit() {
    this.carregar();
  }

  public carregar(){
    if(this.periodo){
        this.isLoading = true;
        this.inscricaoAlunoService.recuperaOrcamento(this.periodo).subscribe(result => {
          this.orcamento = result;

          if(this.orcamento.consolidado >= this.orcamento.orcamento){
              this.corBotaoConsolidado="warn";
          }

          if(this.orcamento.previsto >= this.orcamento.orcamento){
              this.corBotaoPrevisto="warn";
          }

          this.consolidadoString = this.formatar(this.orcamento.consolidado);
          this.orcamentoString = this.formatar(this.orcamento.orcamento);
          this.previstoString = this.formatar(this.orcamento.previsto);
          this.isLoading = false;
        });
    }
  }

  formatar(numero: number){
    let numeroString = numero.toFixed(2).split('.');
    numeroString[0] = "R$ " + numeroString[0].split(/(?=(?:...)*$)/).join('.');
    return numeroString.join(',');
  }

  // mostra erros na tela
   erro(erro: string){
     this.mensagem.open(erro, 'X', {duration: 5000});
     this.isLoading = false;
   }

}
